import React   from 'react';
 
import Select from 'react-select';

const EmploymentTab = ({ register, errors,watch,companies,expLevels,managerSupervisor,employeeType,setValue, currentUserId }) => {
 const selectedCompaniesIds = watch('company_ids');
 
  const selectedCompanies = companies?.data?.filter(c => selectedCompaniesIds?.includes(c.id));
  const managers = Array.isArray(managerSupervisor)
    ? managerSupervisor
    : (managerSupervisor?.data || []);
 
  return (
    <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
      {/* Employee Type */}
      <div>
        <label className="block text-sm font-medium text-gray-700">Employee Type <span className="text-red-500">*</span></label>
        <select
          {...register('employee_type_id')}
          className={`appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-[#009efb] focus:border-[#009efb] sm:text-sm ${
            errors.employee_type_id ? 'border-red-500' : ''
          }`}
        >
          <option value="" className='text-gray-400'>Select Type</option>
          {employeeType?.map(type => (
            <option key={type.id} value={type.id}>{type.name}</option>
          ))}
          
        </select>
        {errors.employee_type_id && (
          <p className="mt-1 text-sm text-red-600">{errors.employee_type_id.message}</p>
        )}
      </div>

     {/* Company Name */}
      <div>
        <label className="block text-sm font-medium text-gray-700">Company Name <span className="text-red-500">*</span></label>
        <Select
          className={`appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-[#009efb] focus:border-[#009efb] sm:text-sm ${
            errors.company_ids ? 'border-red-500' : ''
          }`}
        {...register('company_ids')}
        isMulti
        value={selectedCompanies?.map(c => ({ label: c.name, value: c.id }))}
        options={companies?.data?.map(c => ({ label: c.name, value: c.id }))}
        onChange={(selected) => {
          const ids = selected.map(item => item.value);
          setValue('company_ids', ids);
          
        }}
        classNamePrefix="react-select"
      />
        {errors.company_ids && (
          <p className="mt-1 text-sm text-red-600">{errors.company_ids.message}</p>
        )}

      </div>


      {/* Job Title */}
      <div>
        <label className="block text-sm font-medium text-gray-700">Job Title</label>
        <input
          type="text"
          {...register('job_title')}
          className="appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-[#009efb] focus:border-[#009efb] sm:text-sm"
          placeholder="Enter Job Title"
        />
      </div>

      {/* Department */}
      <div>
        <label className="block text-sm font-medium text-gray-700">Department</label>
        <input
          type="text"
          {...register('department')}
          className="appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-[#009efb] focus:border-[#009efb] sm:text-sm"
          placeholder="Enter Department"
        />
      </div>

      {/* Hire Date */}
      <div>
        <label className="block text-sm font-medium text-gray-700">Hire Date</label>
        <input
          type="text"
          {...register('hire_date')}
          onInput={(e) => {
            setValue('hire_date', e.target.value);
          }}
          className="appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-[#009efb] focus:border-[#009efb] sm:text-sm datepicker"
          placeholder="Enter Hire Date"
        />
      </div>

      {/* Original Hire Date */}
      <div>
        <label className="block text-sm font-medium text-gray-700">Original Hire Date</label>
        <input
          type="text"
          {...register('original_hire_date')}
          onInput={(e) => {
            setValue('original_hire_date', e.target.value);
          }}
          className="appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-[#009efb] focus:border-[#009efb] sm:text-sm datepicker"
          placeholder="Enter Original Hire Date"
        />
      </div>

      {/* Adjusted Service Date */}
      <div>
        <label className="block text-sm font-medium text-gray-700">Adjusted Service Date</label>
        <input
          type="text"
          {...register('adjusted_service_date')}
          onInput={(e) => {
            setValue('adjusted_service_date', e.target.value);
          }}
          className="appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-[#009efb] focus:border-[#009efb] sm:text-sm datepicker"
          placeholder="Enter Adjusted Service Date"
        />
      </div>

      {/* Release Date */}
      <div>
        <label className="block text-sm font-medium text-gray-700">Release Date</label>
        <input
          type="text"
          {...register('release_date')}
          onInput={(e) => {
            setValue('release_date', e.target.value);
          }}
          className="appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-[#009efb] focus:border-[#009efb] sm:text-sm datepicker"
          placeholder="Enter Release Date"
        />
      </div>

      {/* Manager/Supervisor */}
      <div>
        <label className="block text-sm font-medium text-gray-700">Manager/Supervisor</label>
        <Select
          className="appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-[#009efb] focus:border-[#009efb] sm:text-sm"
          classNamePrefix="react-select"
          placeholder="Select Manager"
          isClearable
          options={managers
            .filter((manager) => String(manager.id) !== String(currentUserId || ''))
            .map((manager) => ({
              value: manager.id,
              label: `${manager.first_name || ''} ${manager.last_name || ''}`.trim() || 'Unnamed',
            }))}
          value={(() => {
            const selectedId = watch('manager_id');
            if (selectedId === '' || selectedId === null || typeof selectedId === 'undefined') return null;
            const manager = managers.find((item) => String(item.id) === String(selectedId));
            return manager
              ? { value: manager.id, label: `${manager.first_name || ''} ${manager.last_name || ''}`.trim() || 'Unnamed' }
              : null;
          })()}
          onChange={(selected) => {
            setValue('manager_id', selected?.value || '', { shouldDirty: true, shouldValidate: true });
          }}
        />
      </div>

      {/* Group Assignment */}
      <div>
        <label className="block text-sm font-medium text-gray-700">Group Assignment</label>
        <input
          type="text"
          {...register('group_assignment')}
          className="appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-[#009efb] focus:border-[#009efb] sm:text-sm"
          placeholder="Enter Group Assignment"
        />
      </div>

      {/* Experience Level */}
      <div>
        <label className="block text-sm font-medium text-gray-700">Experience Level</label>
        <select
          {...register('experience_level_id')}
          className="appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-[#009efb] focus:border-[#009efb] sm:text-sm"
        >
          <option value="" className='text-gray-400'>Select Level</option>
          {expLevels?.map(expLevel => (
            <option key={expLevel.id} value={expLevel.id}>{expLevel.name}</option>
          ))}
          
        </select>
      </div>
    </div>
  );
};

export default EmploymentTab; 